import fileDefault from "../assets/img/file-blank-solid-240.png";
import fileCSS from "../assets/img/file-css-solid-240.png";
import filePdf from "../assets/img/file-pdf-solid-240.png";
import filePng from "../assets/img/file-png-solid-240.png";

export const ImageConfig = {
  default: fileDefault,
  pdf: filePdf,
  png: filePng,
  css: fileCSS
};
